import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealLines } from "@/components/motion";
import { EmptyState } from "@/components/EmptyState";
import { CASES } from "@/data/content";

export const CaseStudiesPreview = () => {
  const navigate = useNavigate();
  return (
    <section
      id="case-studies"
      className="py-28 md:py-40 bg-[#26231F] text-[#FDFBF7]"
      data-testid="case-studies-preview"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-6">— Case Studies</p>
            <h2 className="font-serif font-light text-5xl md:text-7xl tracking-tight leading-none">
              <RevealLines lines={["Proof, not", "promises."]} />
            </h2>
          </div>
          <button
            onClick={() => navigate("/case-studies")}
            data-testid="view-all-cases"
            className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] whitespace-nowrap text-[#FDFBF7]"
          >
            All case studies
            <ArrowUpRight size={16} className="text-[#C5A059] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {CASES.length === 0 && <EmptyState dark label="Case studies — coming soon" note="Client results and stories will appear here soon." />}
          {CASES.map((c, i) => (
            <Reveal key={c.slug} i={i}>
              <button
                onClick={() => navigate(`/case-studies/${c.slug}`)}
                data-testid={`case-card-${c.slug}`}
                className="group text-left w-full"
              >
                <div className="relative overflow-hidden aspect-[16/9] mb-5">
                  <motion.img
                    src={c.img}
                    alt={c.title}
                    className="w-full h-full object-cover"
                    whileHover={{ scale: 1.06 }}
                    transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#26231F]/70 to-transparent" />
                </div>
                <p className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">{c.tag}</p>
                <h3 className="font-serif text-3xl mt-2 leading-tight">{c.title}</h3>
                <div className="flex gap-6 mt-4">
                  {c.metrics.slice(0, 2).map(([n, l]) => (
                    <div key={l}>
                      <div className="font-serif text-2xl text-[#C5A059]">{n}</div>
                      <div className="text-[11px] text-[#FDFBF7]/50 uppercase tracking-wide">{l}</div>
                    </div>
                  ))}
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
